module.exports = __webpack_public_path__ + "img/parse.3d1074d8.gif";